import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";

import BonusesHistory from "../../../containers/admin/premium/BonusesHistory";
import { fetchPremiumList } from "../../../redux/actions/premiumActions";
import { selectUserRoleId } from "../../../redux/selectors/user";
import { currentClientSelector } from "../../../redux/selectors/auth";
import MenuPresence from "./../Menu";
import AuthRender from "../../../containers/AuthRender";
import { SERVICES } from "../../../configs/constants";
const BonusesHistoryContainer = props => {
  useEffect(() => {
    props.setMenuTopIndex("presence");
    props.setMenuLeftContent(MenuPresence);
    props.setMenuLeftIndex("bonushistory");
    props.setMenuLeftItemIndex("");
  }, []);

  return (
    <AuthRender service={SERVICES.Primes}>
      <BonusesHistory {...props} />
    </AuthRender>
  );
};

const mapStateToProps = state => {
  const client = currentClientSelector(state);
  return {
    token: state.auth.token,
    rejectTypes: state.expenseReports.rejectTypes,
    roleId: selectUserRoleId(state),
    bonuses: state.premium.premiumList,
    clientId: client.id,
    clientLabel: client.label
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    fetchBonuses: payload => dispatch(fetchPremiumList(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BonusesHistoryContainer);



// WEBPACK FOOTER //
// src/pages/presence/premium/BonusesHistory.container.js